import React from 'react'
import styles from './LeftDrawer.module.scss';

interface ILeftDrawer {
  children: React.ReactNode
}

export const LeftDrawer = ({children}: ILeftDrawer) => {
  return (
    <div className={styles.drawerWrapper}>
      {children}
    </div>
  )
}
